export { default, type AccordionItemHeaderProps } from './AccordionItemHeader';
